module.exports = __webpack_public_path__ + "static/media/justfollowit-trial.ae6d1614.png";